import type { Permission } from "../types/permission.types";

export interface PermissionGroup {
  group: string;
  items: Permission[];
}

export const groupByPermissionGroup = (
  permissions: Permission[] | undefined,
): PermissionGroup[] => {
  if (!permissions) return [];
  const map = new Map<string, Permission[]>();
  for (const p of permissions) {
    const key = p.permissionGroup || "기타";
    const arr = map.get(key) ?? [];
    arr.push(p);
    map.set(key, arr);
  }
  return Array.from(map.entries())
    .sort(([a], [b]) => a.localeCompare(b))
    .map(([group, items]) => ({
      group,
      items: items.sort((a, b) => a.code.localeCompare(b.code)),
    }));
};
